import React from "react";
import styled from "styled-components";

export const BenefitTable: React.FC<{}> = () => {
  const [showEmployee, setShowEmployee] = React.useState(false);

  return (
    <StyledBenefitTable className="">
      <BenefitHeader>
        <BenefitSelector
          active={!showEmployee}
          onClick={() => setShowEmployee(false)}
        >
          <h1 className="h4 mb-0">For the organisation</h1>
        </BenefitSelector>
        <BenefitSelector
          active={showEmployee}
          onClick={() => setShowEmployee(true)}
        >
          <h1 className="h4 mb-0">For employees</h1>
        </BenefitSelector>
      </BenefitHeader>
      <BenefitContent active={!showEmployee}>
        <BenefitList>
          <li>A comprehensive health and safety program</li>
          <li>A positive and caring image</li>
          <li>Improved staff morale</li>
          <li>Reduced staff turnover</li>
          <li>Reduced sick leave</li>
          <li>Increased productivity</li>
          <li>Reduced risk of fines and litigation</li>
        </BenefitList>
        <BenefitList>
          <li>A safe and healthy work environment</li>
          <li>Enhanced self-esteem</li>
          <li>Improved morale</li>
          <li>Reduced stress</li>
          <li>Increased job satisfaction</li>
          <li>Increased health awareness and skills</li>
          <li>Improved health</li>
          <li>Improved sense of wellbeing</li>
        </BenefitList>
      </BenefitContent>
    </StyledBenefitTable>
  );
};

const StyledBenefitTable = styled.div`
  width: 100%;
  overflow: hidden;
`;

const BenefitHeader = styled.div`
  display: flex;
`;

const BenefitSelector = styled.button<{ active: boolean }>`
  width: 50%;
  color: ${(props) =>
    props.active ? props.theme.info : props.theme.secondary};
  background-color: ${(props) => (props.active ? "white" : props.theme.info)};
  border: 1px solid #4494b9;
  padding: 1rem;
`;

const BenefitContent = styled.span<{ active: boolean }>`
  width: 200%;
  display: flex;
  overflow: hidden;
  transition: 500ms all ease;
  transform: ${(props) =>
    props.active ? "translateX(0)" : "translateX(-50%)"};
`;

const BenefitList = styled.ul`
  width: 50%;
  padding: 0;
  list-style: none;
  & li {
    padding: 1rem;
    border: 1px solid #4494b9;
    border-top: none;
  }
`;
